/**
 * Build mailto: links for the public-facing contact CTAs (HD-101).
 *
 * - waitlistMailto: "Notify me at launch" pill on coming-soon product cards.
 * - salesMailto:    "Contact sales" CTA on the Business pricing tier and any
 *                   other place that wants a sales conversation.
 *
 * Recipients come from env (VITE_SALES_EMAIL, VITE_SUPPORT_EMAIL) with
 * production defaults so dev builds work without extra config.
 *
 * These are not real waitlist endpoints — that's intentional. Until a real
 * email-collection backend exists, a pre-filled mailto: is the most honest
 * version of the CTA: it actually sends a message, and the recipient is
 * a real inbox the team owns.
 */

const DEFAULT_SALES_EMAIL = "sales@gen-pro-hub.com";

function salesAddress(): string {
  return import.meta.env.VITE_SALES_EMAIL ?? DEFAULT_SALES_EMAIL;
}

/**
 * Build the "notify me at launch" mailto link for a specific product.
 *
 * @param productId  Product id from the catalog (e.g. "invoice").
 * @param productName Display name shown in the email subject.
 */
export function waitlistMailto(productId: string, productName: string): string {
  const subject = encodeURIComponent(`Waitlist: ${productName}`);
  const body = encodeURIComponent(
    `Hi! I'd like to be notified when ${productName} launches.\n\n` +
      `Product id: ${productId}\n`,
  );
  return `mailto:${salesAddress()}?subject=${subject}&body=${body}`;
}

/**
 * Build the generic "contact sales" mailto link.
 *
 * @param subjectLine Subject line, e.g. "Business plan inquiry".
 */
export function salesMailto(subjectLine: string): string {
  const subject = encodeURIComponent(subjectLine);
  return `mailto:${salesAddress()}?subject=${subject}`;
}
